<div class="flex flex-col h-full">
  <!-- Header Component -->
  <app-header (menuToggle)="toggleSidebar()"></app-header>

  <!-- Main layout with sidebar and content - Takes remaining height -->
  <div class="flex flex-1 overflow-hidden">
    <!-- Sidenav Component -->
    <app-sidenav [(visible)]="sidebarVisible"> </app-sidenav>

    <!-- Main content area - Scrollable -->
    <main class="flex-1 overflow-y-auto">
      <div class="p-6">
        <!-- Router outlet for child routes -->
        <router-outlet></router-outlet>
      </div>
    </main>
  </div>
</div>
